import React from "react";
import { useLoaderData } from "react-router";
import DraftPanel from "./panels/DraftPanel";
import ReviewPanel from "./panels/ReviewPanel";
import OutstandingPanel from "./panels/OutstandingPanel";
import SettledPanel from "./panels/SettledPanel";

export const InvoiceV2DetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV2DetailFrontModel>();

  return <>
    {viewModel.details.lifeCycle.value === "draft" && <DraftPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "review" && <ReviewPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "pending" && <OutstandingPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "completed" && <SettledPanel
      viewModel={viewModel}
    />}
  </>
}